import React, { useState } from 'react';
import { Box } from '@mui/material';
import CustomAppBar from '../Common/Layout/CustomAppBar';
import TabPanel from '../Common/Layout/TabPanel';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import HistoryIcon from '@mui/icons-material/History';
import RecipientList from './RecipientList';
import Templates from './Templates';
import Scheduler from './Scheduler';

const MassMailInfoWrapper: React.FunctionComponent = () => {
  const [value, setValue] = useState(0);

  return (
    <Box style={{ width: '100%' }}>
      <Box>
        <CustomAppBar
          value={value}
          handleChange={(_, newValue) => setValue(newValue)}
          type="first"
          tabProps={[
            {
              id: 'recipient-list-tab',
              title: 'Recipient List',
              icon: ReceiptIcon
            },
            {
              id: 'templates-tab',
              title: 'Templates',
              icon: ImportContactsIcon
            },
            {
              id: 'scheduler-tab',
              title: 'Scheduler',
              icon: HistoryIcon
            }
          ]}
        />
        <Box>
          <TabPanel value={value} index={0}>
            <RecipientList />
          </TabPanel>
        </Box>
        <TabPanel value={value} index={1}>
          <Templates />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Scheduler />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default MassMailInfoWrapper;
